import { AdditionalProcesses } from "@/api/klip-api.proxy";
import { computed, defineComponent, onMounted, ref } from "vue";
import {AdminOrganisationDetail, AdminSettings} from "@/app/admin/admin-routes";
import {useKlipApiProxy} from '@/plugins/proxy-client';
import {RouteRecordRaw} from 'vue-router';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlAdditionalProcesses',
    setup() {
        const proxy = useKlipApiProxy();
        const additionalProcesses = ref<AdditionalProcesses>();

        const routeAdminSettings = computed((): RouteRecordRaw => {
            return AdminSettings;
        });

        const routeAdminOrganisationDetail = computed((): RouteRecordRaw => {
            return AdminOrganisationDetail;
        });

        onMounted(async () => {
            const additionalProcessesResult = await proxy.processes_AdditionalProcesses();
            if (additionalProcessesResult.isSuccessStatusCode) {
                additionalProcesses.value = additionalProcessesResult.result
            }
        });

        return {
            additionalProcesses,
            routeAdminSettings,
            routeAdminOrganisationDetail
        };
    }
});
